export class Session {
  login: boolean;
  user: any;
  loading: boolean;
  opened: boolean;
  googleAuth: boolean;
  token: string;
  personalSetting: any;
  nabelAdmin?: boolean;
  customerAdmin?: string[];
  permitted?: string[];
  passwordUpdated: boolean;

  constructor() {
    this.login = false;
    this.loading = false;
    this.opened = true;
    this.googleAuth = false;
    this.token = '';
    this.passwordUpdated = false;
  }

  reset(): void {
    // 追加
    this.login = false;
    this.loading = false;
    this.user = null;
    this.googleAuth = false;
  }
}
